import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import AppRoutes from "./routes";
import { useAppDispatch } from "./app/hooks";
import { loadFromStorage } from "./app/features/authSlice";

function App() {
  const dispatch = useAppDispatch();

  // Rehydrate the admin session from localStorage on first paint
  useEffect(() => {
    dispatch(loadFromStorage());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
